import {Component, OnInit} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {SessionService} from "../../../common/session.service";
import {LoggerService} from "../../../common/logger.service";
import {UsanaObject} from "../../../usana-object";
import {ShareableUtil} from "../../../social/shareable-util";
import {IResolvedShopUser} from "../../../session/customer-models";

@Component({
    selector: 'sponsor-change-modal',
    templateUrl: './sponsor-change-modal.component.html',
    styleUrls: ['./sponsor-change-modal.component.scss'],
    standalone: false
})
export class SponsorChangeModalComponent extends UsanaObject implements OnInit {

    form: UntypedFormGroup;
    loading: boolean = false;
    showError: boolean = false;

    constructor(
        public modalRef: BsModalRef,
        loggerService: LoggerService,
        private sessionService: SessionService
    ) {
        super(loggerService);
    }

    ngOnInit(): void {
        this.form = new UntypedFormGroup({
            subdomain: new UntypedFormControl('', [Validators.required, Validators.minLength(1)])
        });
    }

    submit(): void {
        if (this.form.invalid || this.loading) return;

        this.loading = true;
        this.showError = false;
        const input = this.form.get('subdomain').value.trim();

        // The gateway takes the raw input as a ref, resolving it as a subdomain and then as a raw
        // sponsor id. Changing the sponsor changes attribution, so this reloads the shop user too.
        this.sessionService.applyAttribution({ref: input}).subscribe({
            next: (resolved: IResolvedShopUser) => {
                this.loading = false;
                // A well-formed but nonexistent id comes back as empty details rather than an error,
                // so a valid sponsor has to be confirmed before treating this as a success.
                if (!ShareableUtil.isSponsorIdPresent(resolved.sponsorDetails)) {
                    this.showError = true;
                    return;
                }
                if (!resolved.sponsorDetails.sponsorName) {
                    // The captcha gate answers with the id alone, so the sponsor still applies but
                    // cannot be named until something resolves them again.
                    this.log.warn("submit", "sponsor changed but could not be named", resolved.sponsorDetails.sponsorId);
                }
                this.modalRef.hide();
            },
            error: (err: unknown) => {
                this.log.error("submit", `could not change the sponsor to ${input}`, err);
                this.loading = false;
                this.showError = true;
            }
        });
    }
}
